export default __webpack_public_path__ + "static/media/bg@1x.273eeb3b.webp";